import $ from 'cash-dom';
import { getCookie, setCookie } from '../utilities/cookies';

const cookie = getCookie('signup-modal');
const modal = $('[data-element="signup-modal"]');

if (cookie === null && modal) {
	const delay = $(modal).find('aside').attr('data-modal-settings') * 1000;

	setTimeout(() => {
		showmodal();
	}, delay);
}

const showmodal = () => {
	modal.attr('aria-hidden', false);
	modal.removeClass('hidden');
	setCookie('signup-modal', 'viewedmodal', 7);
};

const closemodal = () => {
	modal.addClass('hidden');
};

$('[data-action="close-signup-modal"]').on('click', () => {
	closemodal();
});
